const ValidationStatus = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  PENDING: 'PENDING',
  NOT_VALIDATED: 'NOT_VALIDATED',
};

export default ValidationStatus;
